// Pure class-composition seam for single-line and multi-line text fields. Mirrors
// button-classes.ts: one place owns the look, the components in TextField.tsx are
// thin consumers. `className` is for layout only (mt-1, max-w-*), never for
// restyling; a sizing or colour need there means the seam needs a variant.

export interface TextFieldClassesOptions {
  /** Monospace at 12px for prompts, templates and other line-scanned text. */
  mono?: boolean;
  /** Textarea: allow vertical resize. */
  multiline?: boolean;
  className?: string;
}

// Same field tokens as SecretInput: rounded bg-surface, hairline ring, ink/30
// focus ring. Disabled doubles as the read-only look (empty-state wash, ink/30
// text), so callers never invent a separate read-only style.
const BASE =
  "field-value w-full rounded-md bg-surface px-3 py-2.5 text-ink ring-1 ring-ink/10 transition " +
  "placeholder:text-ink/30 focus:outline-none focus:ring-ink/30 " +
  "disabled:cursor-not-allowed disabled:bg-ink/[0.02] disabled:text-ink/30";

const MONO = "font-mono text-[12px] leading-relaxed";
const MULTILINE = "resize-y";

export function textFieldClasses({
  mono = false,
  multiline = false,
  className = "",
}: TextFieldClassesOptions = {}): string {
  return [BASE, mono ? MONO : "", multiline ? MULTILINE : "", className].filter(Boolean).join(" ");
}
